import { Menu } from "@mui/material";
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import store from "../../../redux/store";
import MenuIcon from "@mui/icons-material/Menu";
import AdminHeaderAction from "../../../redux/adminPanel/header/AdminHeaderAction";
import AdminAppUserDataAction from "../../../redux/adminPanel/appUserData/AdminAppUserDataAction";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import "./AdminNavbar.css";
import { ApLogout_Url } from "../../../provider/ServiceUrl";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import AppUserRoleAction from "../../../redux/adminPanel/appUserRole/AppUserRoleAction";
// import staticDataAction from "../../../redux/staticData/staticDataAction";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { NavLink } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import LogoutIcon from '@mui/icons-material/Logout';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
class AdminNavbar extends Component {
  header = store.getState().adminHeader.adminHeader;
  userName = store.getState().adminUserDetails.adminUserDetails;
  constructor(props) {
    super(props);
    let menuList =
      store.getState().adminUserDetails.adminUserDetails?.profile?.menus;
    let adminActiveMenu = store.getState().appUserRole?.adminActiveMenu;

    if (undefined === adminActiveMenu || null === adminActiveMenu) {
      adminActiveMenu = (menuList && menuList.length) > 0 ? menuList[0].id : -1;
    }
    this.state = {
      menuItems: menuList,
      adminActiveMenu: adminActiveMenu,
      open: false,
      anchorEl: null,
      isMenuList: false,
    };
  }

  toggleSidebar = () => {
    let overlay = document.getElementById("overlay");
    let loaderClasses = document.getElementById("pageLoader").classList;
    let loaderWithTextClasses =
      document.getElementById("loader-with-text").classList;
    if (
      loaderClasses.contains("show-loader") ||
      loaderWithTextClasses.contains("text-loader-show")
    ) {
      return;
    }

    overlay.addEventListener("click", this.toggleSidebar);

    let appClasses = document.getElementById("app").classList;
    let overlayClasses = overlay.classList;

    if (appClasses.contains("sidebar-menu-extended")) {
      appClasses.remove("sidebar-menu-extended");
      overlayClasses.remove("overlay-active");
    } else {
      appClasses.add("sidebar-menu-extended");
      overlayClasses.add("overlay-active");
    }
  };

  handleAccountDropdownOpen = (e) => {
    this.setState({ open: true, anchorEl: e.currentTarget });
  };

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };
  profile = () => {
    this.props.navigate("/ApProfile");
  };
  logOut = () => {
    let postObject = {
      header: this.header,
    };
    AdminFetchServerData.callPostService(ApLogout_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          store.dispatch(staticDataAction.setStaticData({}));
          store.dispatch(AppUserRoleAction.setAdminActiveMenu({}));
          store.dispatch(AdminHeaderAction.setAdminHeader({}));
          store.dispatch(AdminAppUserDataAction.setAdminUser({}));
          this.props.navigate("/APLogin");
          localStorage.removeItem("apHeader");
          localStorage.removeItem("apRememberMe");
        }
      }
    );
  };


  goToPage = (e, id, pageid) => {
    this.props.navigate(pageid);
  };

  menuListToggle = () => {
    this.setState({
      isMenuList: !this.state.isMenuList,
      activeElement: "",
    });
  };

  openMenu() {
    this.setState({
      isMenuList: true,
    });
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  render() {
    return (
      <section id="navbar">
        <nav
          className="layout-navbar navbar navbar-expand-lg fixed-top navbar-detached align-items-center bg-navbar-theme adminnavbar"
          style={{
            width: "100%",
            margin: "0px",
            backgroundColor: "#1b2f45",
          }}
          id="layout-navbar"
        >
          <div className="container">
            <div
              className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
              onClick={(e) => this.openMenu()}
            >
              <a
                className="nav-item nav-link px-0 me-4-xl"
                href="javascript:void(0)"
              >
                <i className="bx bx-menu bx-sm" style={{
                  fontSize: "28px",
                  cursor: "pointer",
                  color: "#fff",
                }} />
              </a>
            </div>
            <div className="col text-start">
              <span style={{ color: "#fff", fontSize: "20px" }}>
                <b>Admin Panel</b>
              </span>
            </div>
            <div className="col text-end">
              <span style={{ fontSize: "16px", color: "#fff" }}>
                {this.userName.firstName} {this.userName.lastName}
              </span>{" "}
              &nbsp;
              <MenuIcon
                style={{
                  fontSize: "28px",
                  cursor: "pointer",
                  color: "#fff",
                }}
                aria-controls={this.state.open ? "dropdown-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={this.state.open ? "true" : undefined}
                onClick={this.handleAccountDropdownOpen}
              />
            </div>
          </div>
          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <Menu
              anchorEl={this.state.anchorEl}
              id="dropdown-menu"
              open={this.state.open}
              onClose={this.handleAccountDropdownClose}
              onClick={this.handleAccountDropdownClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 20,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <li>
                <div
                  className="dropdown-item ps-3"
                  onClick={this.profile}
                  style={{ cursor: "pointer" }}
                >
                  <span className="align-middle"><PermIdentityOutlinedIcon style={{ fontSize: "25px" }} /> Profile</span>
                </div>
              </li>

              <li>
                <div className="dropdown-divider"></div>
              </li>
              <li>
                <div
                  className="dropdown-item"
                  onClick={this.logOut.bind(this)}
                  style={{ cursor: "pointer" }}
                >
                  <span className="align-middle"> <LogoutIcon style={{ fontSize: "large" }} /> Sign Out</span>
                </div>
              </li>
            </Menu>
          </ul>
          <Modal
            isOpen={this.state.isMenuList}
            toggle={this.menuListToggle}
            size="sm"
            style={{ marginTop: "5em" }}
          >
            <Row>
              <Col md={12}>
                <CloseIcon
                  onClick={(e) => this.menuListToggle()}
                  style={{ float: "right", margin: "0.5em 1em 0em 0em" }}
                />
              </Col>
            </Row>
            <ModalBody style={{ padding: "0.5em" }}>
              <nav className="mobileViewTopNav">
                <ul className="p-1" style={{ backgroundColor: "#fff" }}>
                  {this.state.menuItems
                    ?.sort((a, b) => a.displaysequence - b.displaysequence)
                    .map((menu, index) => {
                      if (!this.isEmpty(menu)) {
                        return menu.isactive === true ? (
                          <li
                            className="text-center"
                            onClick={(e) =>
                              this.goToPage(e, menu.id, menu.pageid)
                            }
                            key={index}
                          >
                            <NavLink
                              to={menu.pageid}
                              className="menu-link"
                              style={{
                                background: menu.isActive ? "#37517e" : "#d3d8de",
                                color: menu.isActive ? "#fff" : "#000",
                                borderRadius: "10px",
                              }}
                              key={index}
                            // onSelect={this.selectedChildMenu.bind(this)}
                            // onClick={(e) =>
                            //   this.getChildMenus(e, menu.id, menu.pageid)
                            // }
                            >
                              <div data-i18n="Dashboards" className="p-2 ps-3">
                                {menu.uiname}
                              </div>
                            </NavLink>
                          </li>
                        ) : (
                          <div></div>
                        );
                      }
                    })}
                </ul>
              </nav>
            </ModalBody>
          </Modal>
        </nav>
      </section>
    );
  }
}

export default withRouter(AdminNavbar);
